import { makeStyles, createStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

interface StyleProps {
  width: number;
  height: number;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: (props) => ({
      display: "flex",
      flexDirection: "row",
      width: props.width,
      marginTop: 5,
      marginBottom: 3,
    }),
    innerBlock: (props) => ({
      display: "flex",
      width: props.width - 1,
      height: props.height - 1,
      backgroundColor: theme.palette.gray30.main,
      border: `1px solid ${theme.palette.gray30.main}`,
      borderRadius: 2,
    }),
  })
);

export default useStyles;
